import customSelect from './custom-select.vue';
export default customSelect;
